import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {Configuration} from "../../assets/Configuration";
import { HttpClient, HttpParams } from "@angular/common/http";
import { WebinarAttendeeModel } from "../models/course/webinar-attendee.model";
import { CourseParticipationStatusModel } from "../models/course/course-participation-status.model";
import { VideoProgressModel } from '../models/video-progress.model';

@Injectable({
    providedIn: 'root'
})
export class CourseService {

    constructor(private httpClient: HttpClient) {
    }

    public trackVideoProgress(courseTemplateId: string, videoProgressSeconds: number): Observable<WebinarAttendeeModel> {
        const params = new HttpParams()
            .set('videoProgressSeconds', videoProgressSeconds);
        
        return this.httpClient.post<WebinarAttendeeModel>(
            Configuration.getApiBaseUrl() + "/course/" + courseTemplateId + "/track-video-progress",
            {},
            { params: params }
        );
    }

    public getVideoProgress(courseTemplateId: string): Observable<VideoProgressModel> {
        return this.httpClient.get<VideoProgressModel>(
            Configuration.getApiBaseUrl() + "/course/" + courseTemplateId + "/video-progress",
        );
    }


    public complete(courseTemplateId: string): Observable<void> {
        return this.httpClient.post<void>(Configuration.getApiBaseUrl() + "/course/" + courseTemplateId + "/complete", {});
    }

    public completeCourseForPerson(courseTemplateId: string, personId: string): Observable<void> {
        return this.httpClient.post<void>(
            Configuration.getApiBaseUrl() + `/course/${courseTemplateId}/complete-for/${personId}`, 
            {}
        );
    }

    public getParticipationStatus(courseTemplateId: string): Observable<CourseParticipationStatusModel> {
        return this.httpClient.get<CourseParticipationStatusModel>(Configuration.getApiBaseUrl() + "/course/" + courseTemplateId + "/participation-status");
    }

    public getExternalUrl(courseTemplateId: string): Observable<string> {
        return this.httpClient.get(Configuration.getApiBaseUrl() + "/course/" + courseTemplateId + "/external-url", {responseType: 'text'});
    }

    public setStatusStarted(courseTemplateId: string): Observable<void> {
        return this.httpClient.post<void>(Configuration.getApiBaseUrl() + "/course/" + courseTemplateId + "/set-status-started", {});
    }
}
